import { List } from "immutable";

export default {
  features: List(),
}
